export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function isSlowConnection(): boolean {
  if (typeof navigator === 'undefined' || !('connection' in navigator)) {
    return false;
  }

  const conn = (navigator as any).connection;
  if (!conn) return false;

  return conn.saveData ||
         conn.effectiveType === 'slow-2g' ||
         conn.effectiveType === '2g' ||
         conn.effectiveType === '3g';
}

export function shouldUseDegradedMode(): boolean {
  return isMobileDevice() && isSlowConnection();
}

export async function withTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number = 5000,
  fallbackValue?: T
): Promise<T> {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) =>
      setTimeout(() => {
        if (fallbackValue !== undefined) {
          return fallbackValue;
        }
        reject(new Error(`Operation timeout after ${timeoutMs}ms`));
      }, timeoutMs)
    ),
  ]);
}

export function logPerformance(label: string, startTime: number) {
  const duration = performance.now() - startTime;
  if (duration > 2000) {
    console.warn(`[Performance] ${label} took ${duration.toFixed(0)}ms`);
  }
}
